import { Routes } from '@angular/router';
import { permissionGuard } from '../../../lib/guards/permission.guard';
import { unsavedChangesGuard } from '../../../lib/guards/unsaved-changes.guard';
import { RESTAURANT_CONFIG } from './base/restaurant-configs';

/**
 * 식당 전용 라우팅
 *
 * mrhst 통합 라우팅과 독립적으로 동작.
 * RESTAURANT_CONFIG.routePath 경로로 등록.
 */
export const restaurantRoutes: Routes = [
  {
    path: RESTAURANT_CONFIG.routePath,
    canActivate: [permissionGuard('RESTAURANT_GOODS$READ')],
    children: [
      {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full',
      },
      {
        path: 'list',
        canDeactivate: [unsavedChangesGuard],
        loadComponent: () =>
          import(
            './components/smart/restaurant-list-page/restaurant-list-page.component'
          ).then((m) => m.RestaurantListPageComponent),
        data: {
          config: RESTAURANT_CONFIG,
          title: '식당',
        },
        children: [
          {
            path: ':id',
            canDeactivate: [unsavedChangesGuard],
            loadComponent: () =>
              import(
                './components/smart/restaurant-detail-page/restaurant-detail-page.component'
              ).then((m) => m.RestaurantDetailPageComponent),
            data: {
              config: RESTAURANT_CONFIG,
              title: '식당 상세',
            },
          },
        ],
      },
    ],
  },
];
